/*
 * @Author: guoyu
 * @Date: 2021-04-12 17:19:24
 * @LastEditors: your name
 * @LastEditTime: 2021-04-13 17:36:00
 * @Description: im信令方法回调
 */
const IM_CALL_METHODS = {};

export function imCall(options = {}) {
  const { type: methodName, data } = options;
  const handle = getCallFn(methodName)
  if (typeof handle === 'function') {
    handle(data)
  }
}

/**
 * @description: 获取要执行的方法
 * @param {*} methodName
 * @return {*}
 */
export function getCallFn(methodName) {
  const callFns = IM_CALL_METHODS[methodName];
  if (!callFns) {
    console.warn(methodName, '不存在');
    return;
  }
  const { fn, args = [], once } = callFns;
  return function handle(data) {
    const callArgs = [data, ...args];
    fn(...callArgs);
    if (once) {
      delete IM_CALL_METHODS[methodName];
    }
  };
}

/**
 * @description: 设置要执行的方法
 * @param {*} methodName
 * @param {*} options fn: 执行的函数体 once: 是否只执行一次 args: 固定的参数
 * @return {*}
 */
export function setCallFn(methodName, options = {}) {
  if (typeof options === 'function') {
    options = {
      fn: options
    };
  }
  if (IM_CALL_METHODS[methodName]) {
    console.warn(methodName, '已经存在,当前操作将更新覆盖');
  }

  if (!options.fn) return;

  IM_CALL_METHODS[methodName] = options;
}
